export enum ApiCacheKeys {
  ENV_VARIABLES = 'env-variables',
  SITEMAP = 'sitemap',
  SYSTEM_VARIABLES = 'systemVariables',
  USER_SETTINGS = 'myprofile'
}
